export const CITIES = [
  'Gachancipá',
  'Sopó',
  'Zipaquirá',
  'Tocancipá',
  'Suesca',
  'Sesquilé',
  'Guatavita'
];

export const PROPERTY_TYPES = [
  'Casa',
  'Apartamento',
  'Lote',
  'Finca',
  'Bodega / Local'
];

export const OPERATIONS = [
  'Venta',
  'Arriendo'
];

export const CITY_SLUGS = {
  'gachancipa': 'Gachancipá',
  'sopo': 'Sopó',
  'zipaquira': 'Zipaquirá',
  'tocancipa': 'Tocancipá',
  'suesca': 'Suesca',
  'sesquile': 'Sesquilé',
  'guatavita': 'Guatavita',
};

export function slugifyCity(cityName) {
  if (!cityName) return '';
  return cityName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-');
}

export function getCityFromSlug(slug) {
  if (!slug) return null;
  let normalizedSlug = slugifyCity(slug);
  if (normalizedSlug.startsWith('en-')) {
    normalizedSlug = normalizedSlug.replace(/^en-/, '');
  }
  if (CITY_SLUGS[normalizedSlug]) {
    return CITY_SLUGS[normalizedSlug];
  }
  return CITIES.find((c) => slugifyCity(c) === normalizedSlug) || null;
}
